import { r as registerInstance, i as writeTask, h, e as Host, g as getElement } from './index-6c727dca.js';
import './component-errors-b6f1109b.js';
import { k as klassList } from './utils-c16d9285.js';

const epiIconCss = ".epi-icon{--epiIcon_top:2px;--epiIcon_position:relative;position:var(--epiIcon_position, relative);top:var(--epiIcon_top, 0)}.epi-icon__icon-name{visibility:hidden}.epi-icon__use{color:var(--grey)}.epi-icon__use.m--color-primary{color:var(--brandPrimary)}.epi-icon__use.m--color-accent{color:var(--brandAccent)}.epi-icon__use.m--color-warn{color:var(--brandWarn)}.epi-icon__use.m--color-secondary{color:var(--brandSecondary)}.epi-icon__use.m--color-grey{color:var(--grey)}";

const EpiIcon = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.klassName = `epi-icon`;
    /** The size (in pixels) of the icon */
    this.size = 32;
    /** The color to be used for the icon if available */
    this.color = `grey`;
  }
  /**
   * Lifecycle hooks in the order that they are called. Uncomment to use
  */
  // componentWillLoad() { }
  // componentDidLoad() { }
  // componentWillRender() { }
  componentDidRender() {
    writeTask(() => this.setCustomIconColor());
  }
  // componentWillUpdate() { }
  // componentDidUpdate() { }
  setCustomIconColor() {
    var _a;
    if (/custom:/.test(this.color)) {
      this.useEl.style.color = (_a = this.color) === null || _a === void 0 ? void 0 : _a.split(`:`)[1];
    }
  }
  /**
   * The render() function should always be the last one in the class
  */
  render() {
    return (h(Host, { "aria-hidden": "true", class: this.klassName, style: {
        display: `inline-flex`,
        height: `${this.size}px`,
        width: `${this.size}px`,
      } }, h("svg", { class: `${this.klassName}__svg` }, h("use", { ref: el => this.useEl = el, href: `#${this.use}`, class: klassList(`${this.klassName}__use`, this.color && !this.color.includes(`custom`) && `m--color-${this.color}`) }))));
  }
  static get assetsDirs() { return ["svg-sprites"]; }
  get el() { return getElement(this); }
};
EpiIcon.style = epiIconCss;

export { EpiIcon as epi_icon };
